import React from 'react';
import './App.css';
import { MyRouter } from './components/MyRouter';
import { LanguageProvider } from './context/LanguageContext';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react"
import { ScrollRestorationManager } from './routes/ScrollRestorationManager';

function App() {
  return ( 
  <LanguageProvider>
    <ScrollRestorationManager/>
    <MyRouter />
    <Analytics />
    <SpeedInsights />
  </LanguageProvider>
);
}

export default App;
